<script>
import findIndex from 'lodash/findIndex';
import { DateTime } from 'luxon';
import InfiniteLoading from 'vue-infinite-loading';
import Truncate from '@components/Truncate';
import HomeNewsModel from '@models/HomeNews';
import NewsModal from '@views/news/modal';
import BlockingContainer from '@components/BlockingContainer';
import HeaderComponent from '@components/HeaderComponent';

import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Vue from 'vue';
Vue.use(Viewer);

export default {
  name: 'NewsHomePage',
  page() {
    return {
      title: this.$t('titles.home'),
    };
  },
  components: {
    NewsModal,
    InfiniteLoading,
    BlockingContainer,
    Truncate,
    HeaderComponent,
  },
  data() {
    return {
      selectedNewsRecord: null,
      modalShow: false,
      records: [],
      options: {
        url: 'data-source',
      },
    };
  },
  methods: {
    infiniteHandler($state) {
      const filters = {
        offset: this.records.length,
        limit: 10,
      };
      HomeNewsModel.params(filters)
        .get()
        .then((response) => {
          if (response.length) {
            this.records = this.records.concat(response);
            $state.loaded();
            if (response.length < this.limit) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        });
    },
    submit(record) {
      const key = findIndex(this.records, { id: record.id });
      if (key !== -1) {
        this.$set(this.records, key, record);
      } else {
        if (this.records.length === 0) {
          this.$nextTick(() => {
            this.$refs.infiniteLoadingRecord.$emit('$InfiniteLoading:reset');
          });
        } else {
          this.records.unshift(record);
        }
      }
      this.close();
    },
    show(id) {
      if (id) this.selectedNewsRecord = id;
      this.modalShow = true;
    },
    close() {
      this.modalShow = false;
      this.selectedNewsRecord = null;
    },
    formatDate(value) {
      return DateTime.fromSQL(value).toFormat('dd.MM.yyyy HH:mm');
    },
  },
};
</script>

<template>
  <div>
    <b-row class="mb-2">
      <b-col>
        <HeaderComponent :title="$t('titles.news')" :button-text="$t('titles.create_news_record')" @button-pressed="show()"></HeaderComponent>
      </b-col>
    </b-row>
    <b-card v-for="(item, $index) in records" :key="$index" class="position-relative mb-2">
      <BlockingContainer v-if="$wait.is(`record ${$index} processing`)"></BlockingContainer>
      <b-row v-viewer="options">
        <b-col v-for="image in item.images" :key="`image${item.id}-${image.id}`" sm="2">
          <b-img-lazy class="pointer mb-sm-0 mb-2" thumbnail fluid :src="image.small" :data-source="image.large" />
        </b-col>
      </b-row>
      <hr v-if="item.images" />
      <b-form-row class="mt-2 mb-2">
        <b-col>
          <h3>{{ item.title }}</h3>
          <Truncate :text="item.content" :limit="0"> </Truncate>
        </b-col>
      </b-form-row>
      <b-row>
        <b-col class="text-right">
          <b-form-text>{{ formatDate(item.created_at) }}</b-form-text>
        </b-col>
      </b-row>
    </b-card>

    <InfiniteLoading ref="infiniteLoadingRecord" spinner="spiral" @infinite="infiniteHandler">
      <span slot="no-more">
        {{ $t('messages.no_more_news') }}
      </span>
    </InfiniteLoading>
    <NewsModal v-model="modalShow" :loaded-id="selectedNewsRecord" @submitted="submit" @hidden="close" />
  </div>
</template>
